var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHpeLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 26,
    viewBox: "0 0 92 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.4096 14.6737V21.0763H92V26H66.1524V9.75H92V14.6737H71.4096Z",
    fill: "#01A982"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5038 0H34.2114V26H39.4685V19.3904H50.4224C57.3432 19.3904 61.3186 15.4922 61.3186 9.74964C61.3184 3.96951 57.343 0 50.5038 0ZM50.1604 14.4071H39.4685V4.92375H50.1604C54.3003 4.92375 55.8705 6.81669 55.8705 9.74964C55.8705 12.6528 54.3003 14.4071 50.1604 14.4071ZM71.4095 7.33597H66.1524V0H92V4.92375H71.4095V7.33597ZM27.6 0V26H22.3429V15.3443H5.25714V26H0V0H5.25714V10.361H22.3429V0H27.6Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_98"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 26,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHpeLogo);
export default __webpack_public_path__ + "static/media/hpe-logo.6a548c8c35e33d8365b0b48573cc2a6e.svg";
export { ForwardRef as ReactComponent };